import { Height } from "@mui/icons-material";
import { info } from "console";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Colors from "../../constants/Colors";
import {
  ScheduleConsultType,
  UpdateStatus,
} from "../../core/http/service/SchedulingService";
import { Paths } from "../../enums/Paths";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { Button } from "../../pages/company/companyRegister/CompanyRegister.styled";
import DropDownDescription from "../dropdown/DropdownDescription";
import {
  ModalSchedulingButtonsContainer,
  ModalSchedulingCardContainer,
  ModalSchedulingTextCardContainer,
  SchedulingCardModal,
  SchedulingCardModalContainer,
} from "../SchedulingCard/ModalSchedulingCard/ModalSchedulingCard.style";

import { H1, Text } from "../UI/generalLayout/Layout.styled";
import { Spacer } from "../UI/spacer/spacer";
import { SchedulingModalOverFlow } from "./CollaboratorInitialSchedulingModal.styled";
import CollaboratorInitialSchedulingModalRadio from "./CollaboratorInitialSchedulingModalRadio";
import { useSelector } from "react-redux";

export interface CollaboratorInitialModalSchedulingProps {
  modalOpen: boolean;
  consultType?: string; // pode ser undefined se nada selecionado
  onCloseModal: () => void;
}

const CollaboratorInitialModalScheduling: React.FC<
  CollaboratorInitialModalSchedulingProps
> = ({ modalOpen, consultType, onCloseModal }) => {
  const [selectedRadio, setSelectedRadio] = useState<
    ScheduleConsultType | UpdateStatus
  >();
  const { isMobile } = useResponsiveInfo();
  const navigate = useNavigate();
  const dependenteProfile: any = useSelector((state: any) => state.login.dependenteProfile);

  // Se quiser inicializar selectedRadio com o tipo de consulta vindo do pai:
  useEffect(() => {
    if (consultType) {
      setSelectedRadio(consultType as ScheduleConsultType);
    }
  }, [consultType]);

  const [information] = useState({
    clinico: `O médico de família atua na prevenção e promoção de saúde, estando
    capacitado a acolher os colaboradores como um todo e não apenas a
    sua doença, considerando suas necessidades, questões pessoais,
    familiares e laborais.`,
    periodica: `Colaboradores que necessitam de exames complementares para realizar o periódico, 
    conforme o risco ocupacional relacionado a sua função.`,
    preventivo: `Realize seus exames de rastreamento anuais (Mamografia, Ecografia mamária, Ecografia transvaginal, conforme avaliação).`,
  });

  const activeInformation = () => { };

  const onConfirmSchedule = async () => {
    if (selectedRadio) {
      navigate(Paths.Scheduling, { state: { consultType: selectedRadio } });
    }
  };

  return (
    <SchedulingCardModal open={modalOpen}>
      <SchedulingCardModalContainer isMobile={isMobile}>
        <ModalSchedulingCardContainer>
          <ModalSchedulingTextCardContainer>
            <H1>Marcar consulta</H1>
            <Text>Informe abaixo qual tipo de atendimento você deseja:</Text>
          </ModalSchedulingTextCardContainer>
          <Spacer bottom={20} />
          <SchedulingModalOverFlow isMobile={isMobile}>
            <CollaboratorInitialSchedulingModalRadio
              value="Clinica"
              onChange={setSelectedRadio}
              selectedRadio={selectedRadio}
              title="Atendimento Clínico"
              subText={
                isMobile ? (
                  <DropDownDescription
                    title="O que é o atendimento clínico?"
                    onCLick={() => ""}
                    description={information.clinico}
                  />
                ) : (
                  information.clinico
                )
              }
            />
            {/* Não aparecer se for dependente */}
            {
              !dependenteProfile && (
                <>
                  <Spacer bottom={10} />
                  <CollaboratorInitialSchedulingModalRadio
                    value="Periodica"
                    onChange={setSelectedRadio}
                    selectedRadio={selectedRadio}
                    title="Atendimento Periódico"
                    subText={
                      isMobile ? (
                        <DropDownDescription
                          title="O que é o atendimento periódico?"
                          onCLick={() => ""}
                          description={information.periodica}
                        />
                      ) : (
                        information.periodica
                      )
                    }
                  />
                </>
              )
            }

            <Spacer bottom={10} />
            <CollaboratorInitialSchedulingModalRadio
              value="Preventiva"
              onChange={setSelectedRadio}
              selectedRadio={selectedRadio}
              title="Exame Preventivo"
              subText={
                isMobile ? (
                  <DropDownDescription
                    title="O que é o exame preventivo?"
                    onCLick={() => ""}
                    description={information.preventivo}
                  />
                ) : (
                  information.preventivo
                )
              }
            />
          </SchedulingModalOverFlow>
          <Spacer bottom={30} />
          <ModalSchedulingButtonsContainer>
            <Button
              onClick={onCloseModal}
              color={Colors.error}
              backgroundColor={Colors.WHITE}
              borderColor={Colors.error}
            >
              Cancelar
            </Button>
            <Button
              onClick={onConfirmSchedule}
              color={Colors.WHITE}
              backgroundColor={Colors.SPM600}
              disabled={!selectedRadio}
            >
              Confirmar
            </Button>
          </ModalSchedulingButtonsContainer>
        </ModalSchedulingCardContainer>
      </SchedulingCardModalContainer>
    </SchedulingCardModal>
  );
};

export default CollaboratorInitialModalScheduling;
